import React from "react";
import TextField from "@mui/material/TextField";

type Props = {
  name?: string
  setName: React.Dispatch<React.SetStateAction<string>>
}

function NewName({setName, name}: Props) {
  return (
      <TextField id="standard-basic" label="Titel" variant="standard" value={name}
                 onChange={(e) => setName(e.target.value)} required={true}/>
  );
}

export default NewName;